<template>
  <show-goods-table :goods-list="goods_list" class="goods-show-list">
        <template>
            <el-table-column label="商品规格">
                <template slot-scope="scope">
                    {{scope.row.specifications.name}}
                </template>
            </el-table-column>
            <el-table-column label="优惠券" min-width="240">
                <template slot-scope="scope">
                    <el-table :data="customerType==='shower'?scope.row.showerCouponsBack:scope.row.buyerCouponsBack">
                        <el-table-column label="优惠劵名称" max-width="130">
                            <template slot-scope="scope_coupon">
                            {{scope_coupon.row.couponData&&scope_coupon.row.couponData.name}}
                            </template>
                        </el-table-column>
                        <el-table-column label="优惠劵内容">
                            <template slot-scope="scope_coupon">
                            <div>{{scope_coupon.row.discount}}</div>
                            <div>满{{scope_coupon.row.thresholdOfAmount}}元可使用</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="发放数量（张）">
                            <template  slot-scope="scope_coupon">
                                {{scope_coupon.row.couponAmount}}
                                <!-- <wt-input v-model="scope_coupon.row.couponAmount"></wt-input> -->
                            </template>
                        </el-table-column>
                        </el-table>
                </template>
            </el-table-column>
        </template>
  </show-goods-table>
</template>
<script>
import showGoodsTable from '../../pt-promotion-coupon/show-goods-table'
export default {
  components: {
    showGoodsTable
  },
  props: {
    goodsList: {
      type: Array,
      default: function () {
        return []
      }
    },
    customerType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      goods_list: JSON.parse(JSON.stringify(this.goodsList))
    }
  },
  watch: {
    goods_list: {
      handler: function (val) {
        val.forEach((item, index) => {
          let couponsBack = this.customerType === 'shower' ? item.showerCouponsBack : item.buyerCouponsBack
          if (!couponsBack || couponsBack.length < 1) {
            val.splice(index, 1)
          }
        })
      },
      immediate: true
    }
  }
}
</script>
<style lang="less">

</style>
